import { bufferToUrl, hasValue } from '../helpers';
import { isEchoContact, isGatewayContact } from '../receiver_helpers';
import { isContactReceiver } from '../typeguards';
export default [
    '$rootScope',
    'LogService',
    'TimeoutService',
    'WebClientService',
    function ($rootScope, logService, timeoutService, webClientService) {
        const log = logService.getLogger('Avatar-C');
        return {
            restrict: 'E',
            scope: {},
            bindToController: {
                receiver: '=eeeReceiver',
                resolution: '=eeeResolution',
            },
            link: function (scope, elem, attrs) {
                scope.$watch(() => scope.ctrl.receiver, (newReceiver, oldReceiver) => {
                    if (!hasValue(newReceiver)) {
                        return;
                    }
                    if (!hasValue(oldReceiver)) {
                        scope.ctrl.update(false);
                        return;
                    }
                    if (newReceiver.id !== oldReceiver.id ||
                        newReceiver.type !== oldReceiver.type ||
                        newReceiver.color !== oldReceiver.color ||
                        newReceiver.displayName !== oldReceiver.displayName) {
                        scope.ctrl.update(false);
                        return;
                    }
                    if (hasValue(newReceiver.avatar)) {
                        if (hasValue(oldReceiver.avatar)) {
                            if (newReceiver.avatar.high !== oldReceiver.avatar.high ||
                                newReceiver.avatar.low !== oldReceiver.avatar.low) {
                                scope.ctrl.update(false);
                                return;
                            }
                        }
                        else {
                            scope.ctrl.update(false);
                            return;
                        }
                    }
                });
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    let loadingPromise = null;
                    const avatarUri = {
                        high: null,
                        low: null,
                    };
                    this.avatarToUri = (data, res) => {
                        if (!hasValue(data)) {
                            return '';
                        }
                        if (avatarUri[res] === null) {
                            avatarUri[res] = bufferToUrl(data, webClientService.appCapabilities.imageFormat.avatar, log);
                        }
                        return avatarUri[res];
                    };
                    this.update = (initial) => {
                        avatarUri.high = null;
                        avatarUri.low = null;
                        const receiver = this.receiver;
                        this.highResolution = this.resolution === 'high';
                        this.isLoading = this.highResolution;
                        this.backgroundColor = receiver.color;
                        this.receiverName = receiver.displayName;
                    };
                    this.$onInit = function () {
                        this.update(true);
                        this.avatarClass = () => 'avatar-' + this.resolution + (this.isLoading ? ' is-loading' : '');
                        this.avatarExists = () => {
                            if (this.receiver.avatar === undefined
                                || this.receiver.avatar[this.resolution] === undefined
                                || this.receiver.avatar[this.resolution] === null) {
                                return false;
                            }
                            this.isLoading = false;
                            this.backgroundColor = null;
                            return true;
                        };
                        this.getDefaultAvatarUri = (type, highResolution) => {
                            switch (type) {
                                case 'group':
                                    return highResolution
                                        ? 'img/ic_group_picture_big.png'
                                        : 'img/ic_group_t.png';
                                case 'distributionList':
                                    return highResolution
                                        ? 'img/ic_distribution_list_t.png'
                                        : 'img/ic_distribution_list_t.png';
                                case 'contact':
                                case 'me':
                                default:
                                    return highResolution
                                        ? 'img/ic_contact_picture_big.svg'
                                        : 'img/ic_contact_picture_t.png';
                            }
                        };
                        this.getAvatarUri = () => {
                            if (this.avatarExists()) {
                                return this.avatarToUri(this.receiver.avatar[this.resolution], this.resolution);
                            }
                            if (this.highResolution
                                && this.isLoading
                                && this.receiver.avatar !== undefined
                                && this.receiver.avatar.low !== undefined
                                && this.receiver.avatar.low !== null) {
                                return this.avatarToUri(this.receiver.avatar.low, 'low');
                            }
                            return this.getDefaultAvatarUri(this.receiver.type, this.highResolution);
                        };
                        this.requestAvatar = (inView) => {
                            if (this.avatarExists()) {
                                return;
                            }
                            if (inView) {
                                if (loadingPromise === null) {
                                    const loadingTimeout = this.highResolution ? 0 : 500;
                                    loadingPromise = timeoutService.register(() => {
                                        webClientService.requestAvatar({
                                            type: this.receiver.type,
                                            id: this.receiver.id,
                                        }, this.highResolution)
                                            .then((avatar) => {
                                            $rootScope.$apply(() => this.isLoading = false);
                                            loadingPromise = null;
                                        })
                                            .catch((error) => {
                                            log.error(`Avatar request has been rejected: ${error}`);
                                            $rootScope.$apply(() => this.isLoading = false);
                                            loadingPromise = null;
                                        });
                                    }, loadingTimeout, false, 'avatar');
                                }
                            }
                            else if (loadingPromise !== null) {
                                timeoutService.cancel(loadingPromise);
                                loadingPromise = null;
                            }
                        };
                        const isWorkApp = webClientService.clientInfo.isWork;
                        this.showWorkIndicator = () => {
                            if (!isContactReceiver(this.receiver)) {
                                return false;
                            }
                            const contact = this.receiver;
                            return isWorkApp === false
                                && !this.highResolution
                                && contact.identityType === 1;
                        };
                        this.showHomeIndicator = () => {
                            if (!isContactReceiver(this.receiver)) {
                                return false;
                            }
                            const contact = this.receiver;
                            return isWorkApp === true
                                && !isGatewayContact(contact)
                                && !isEchoContact(contact)
                                && contact.identityType === 0
                                && !this.highResolution;
                        };
                        this.showBlocked = () => {
                            if (!isContactReceiver(this.receiver)) {
                                return false;
                            }
                            const contact = this.receiver;
                            return !this.highResolution && contact.isBlocked;
                        };
                    };
                }],
            template: `
                <div class="avatar" ng-class="ctrl.avatarClass()">
                    <div class="avatar-loading" ng-if="ctrl.isLoading">
                        <span></span>
                    </div>
                    <div class="work-indicator" ng-if="ctrl.showWorkIndicator()"
                        translate-attr="{'aria-label': 'messenger.THREEMA_WORK_CONTACT',
                            'title': 'messenger.THREEMA_WORK_CONTACT'}">
                        <img src="img/ic_work_round.svg" alt="Threema Work user">
                    </div>
                    <div class="home-indicator" ng-if="ctrl.showHomeIndicator()"
                        translate-attr="{'aria-label': 'messenger.THREEMA_HOME_CONTACT',
                            'title': 'messenger.THREEMA_HOME_CONTACT'}">
                        <img src="img/ic_home_round.svg" alt="Private Threema contact">
                    </div>
                    <div class="blocked-indicator"  ng-if="ctrl.showBlocked()"
                        translate-attr="{'aria-label': 'messenger.THREEMA_BLOCKED_RECEIVER',
                            'title': 'messenger.THREEMA_BLOCKED_RECEIVER'}">
                        <img src="img/ic_blocked_24px.svg" alt="blocked icon">
                    </div>
                    <img
                         ng-class="ctrl.avatarClass()"
                         ng-style="{ 'background-color': ctrl.backgroundColor }"
                         ng-src="{{ ctrl.getAvatarUri() }}"
                         in-view="ctrl.requestAvatar($inview)"
                         aria-label="avatar {{ ctrl.receiverName }}">
               </div>
            `,
        };
    },
];
